import styled, { css } from 'styled-components';
import { ifProp, palette } from 'styled-tools';

import { Button, FontSizes, fontWeight, FontWeights, minWidth, Text, units } from '@calm-web/design-system';

import calmLogoInlineSvg from '@/../public/_n/images/calm-logo-gradient.svg';
import GridWrapper from '@/components/ui/GridWrapper';

export const Grid = styled(GridWrapper)`
	text-align: left;
	margin: 0;
`;

export const SuccessHeader = styled.h4`
	margin-top: 0;
	${fontWeight(FontWeights.Light)};

	${minWidth('desktop')} {
		margin: 0;
	}
`;

export const SuccessText = styled.div`
	margin-top: 24px;
	p {
		margin-bottom: 24px;
	}
`;

export const StoreButtonsWrapper = styled.div`
	margin: 0 auto;
	display: flex;
	justify-content: space-between;
	width: 260px;
	margin-bottom: 24px;
`;

export const AppleButtonWrapper = styled.div`
	display: inline;
	cursor: pointer;
`;

export const GoogleButton = styled.img`
	cursor: pointer;
	width: 120px;
	height: 40px;
`;

export const LoaderContainer = styled.div`
	margin: 4rem auto;
`;

export const Spacer = styled.div`
	flex: 1;
`;
export const PathwaysWrapper = styled.div<{ isMobile?: boolean }>`
	height: 100vh;
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
	gap: ${p => (p.isMobile ? units(4) : units(2))};
	padding: ${units(0, 2)};
	margin-top: ${units(8)};
`;
export const HeadingWrapper = styled.div`
	display: flex;
	align-items: center;
`;
export const ButtonGroup = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${units(1)};
	width: 100%;
`;
export const PhoneWrapper = styled.div`
	border-top-left-radius: ${units(5)};
	border-top-right-radius: ${units(5)};
	border: 10px solid ${palette('gray1')};
	border-bottom: 0;
	color: ${palette('white')};
	background: ${palette('gradientCalmBrandDark')};
	padding: ${units(8)};

	img {
		border-radius: ${units(2)};
	}
`;

export const QrCodeText = styled(Text)`
	max-width: ${units(24)};
	margin-bottom: ${units(2)};
`;
export const CalmLogoInline = styled(calmLogoInlineSvg)`
	height: ${units(5)};
	margin: ${units(0, 1)};
	vertical-align: baseline;
	// Align baselines
	position: relative;
	top: 3px;
`;

export const SuccessParagraph = styled(Text).attrs({ el: 'p', size: FontSizes.base })`
	margin-bottom: ${units(2)};
`;

export const OuterContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	border-radius: 20px;
	max-width: 460px;
	margin-bottom: ${units(2)};
	margin: ${units(2)};

	${minWidth('tablet')} {
		margin: auto;
		width: 100%;
		max-width: 762px;
	}
`;

export const Container = styled.div`
	text-align: center;

	${minWidth('tablet')} {
		text-align: left;
		width: 460px;
	}
`;

export const Title = styled(Text).attrs({
	noMargin: true,
	el: 'h1',
	color: 'blackAlpha80',
	weight: FontWeights.Medium,
	size: FontSizes['2xl'],
	lineHeight: 1.25,
})``;

export const CtaButton = styled(Button)<{ isAdditionalPaddingAboveCtaButton?: boolean }>`
	${ifProp(
		'isAdditionalPaddingAboveCtaButton',
		css`
			margin-top: ${units(3)};
		`,
	)}
`;
